export const FETCH_PRODUCT_MEMBERS_STARTED = 'FETCH_PRODUCT_MEMBERS_STARTED' as const;
export const FETCH_PRODUCT_MEMBERS_FULFILLED = 'FETCH_PRODUCT_MEMBERS_FULFILLED' as const;
export const UPDATE_PRODUCT_MEMBER_ROLE_STARTED = 'UPDATE_PRODUCT_MEMBER_ROLE_STARTED' as const;
export const UPDATE_PRODUCT_MEMBER_ROLE_FULFILLED = 'UPDATE_PRODUCT_MEMBER_ROLE_FULFILLED' as const;

export const fetchProductMembers = (productId?: unknown) => ({
  type: FETCH_PRODUCT_MEMBERS_STARTED,
  payload: productId,
});

export const fetchProductMembersFulfilled = (data: unknown) => ({
  type: FETCH_PRODUCT_MEMBERS_FULFILLED,
  payload: data,
});

export const updateProductMemberRole = (data: unknown) => ({
  type: UPDATE_PRODUCT_MEMBER_ROLE_STARTED,
  payload: data,
});

export const updateProductMemberRoleFulfilled = (data: unknown) => ({
  type: UPDATE_PRODUCT_MEMBER_ROLE_FULFILLED,
  payload: data,
});
